import { isRichTextData } from '../../data-extractor/components-type-guards';
/**
 * Swap the heading tag (h1–h6) in a stored HTML snippet with minimal change.
 * Legacy semantics are preserved: operate on the first element only.
 * Safeguards:
 * - If extra root nodes (elements or non-empty text) exist, abort to avoid dropping content
 * - Verify textContent before/after is identical; otherwise, return the component unchanged
 */
export const updateHtmlHeadingDataObject = (component, newTag) => {
  var _newDoc$body$firstEle;
  const {
    data,
    type
  } = component;
  if (!isRichTextData(data)) {
    throw new Error(`Component with type: ${type} is not a text component`);
  }
  const oldHeadingHtmlString = data.text;
  const parser = new DOMParser();
  const doc = parser.parseFromString(oldHeadingHtmlString, 'text/html');
  const oldHeadingElement = doc.body.firstElementChild;
  if (!oldHeadingElement) {
    throw new Error(`Old heading tag not found in provided component data`);
  }
  // Abort if the HTML has extra nodes we would drop (stray text/multiple elements)
  const hasNonElementContent = Array.from(doc.body.childNodes).some(n => n.nodeType !== Node.ELEMENT_NODE && (n.textContent ?? '').trim().length > 0);
  const hasMultipleElements = doc.body.children.length > 1;
  if (hasNonElementContent || hasMultipleElements) {
    return component;
  }
  const oldTextContent = oldHeadingElement.textContent ?? '';
  const newHeadingHtmlString = changeHeadingTagLevel(newTag, oldHeadingElement);

  // Ensure text of the element stays identical
  const newDoc = parser.parseFromString(newHeadingHtmlString, 'text/html');
  const newTextContent = ((_newDoc$body$firstEle = newDoc.body.firstElementChild) == null ? void 0 : _newDoc$body$firstEle.textContent) ?? '';
  const normalize = s => s.replace(/\s+/g, ' ').trim();
  if (normalize(oldTextContent) !== normalize(newTextContent)) {
    return component;
  }
  const newData = {
    ...data,
    text: newHeadingHtmlString
  };
  return {
    ...component,
    data: newData
  };
};

/** Create a new element with the desired tag; copy attributes and inner HTML */
export const changeHeadingTagLevel = (newTag, oldHeading) => {
  var _oldHeading$ownerDocu;
  const newHeading = ((_oldHeading$ownerDocu = oldHeading.ownerDocument) == null ? void 0 : _oldHeading$ownerDocu.createElement(newTag)) ?? document.createElement(newTag);
  for (const attr of oldHeading.attributes) {
    newHeading.setAttribute(attr.name, attr.value);
  }
  newHeading.innerHTML = oldHeading.innerHTML;
  return newHeading.outerHTML;
};
//# sourceMappingURL=update-html-heading-data-object.js.map